import { PausePrintRequest } from "../services/print/models/pause-print-request";

/**
 * Report Designer print settings
 */
export class ReportDesignerPrintSettings {
  /**
   * Hide the cover page?
   */
  public hideCoverPage = false;

  /**
   * Hide the back cover page?
   */
  public hideBackCoverPage = false;

  /**
   * Hide page numbers?
   */
  public hidePageNumbers = false;

  /**
   * Include the page header?
   */
  public includeHeader = false;

  /**
   * Include the page footer?
   */
  public includeFooter = false;

  /**
   * Print mode: PDF or HTML
   */
  public printMethod = 6;

  /**
   * Add cover page?
   */
  public coverPage = true;

  /**
   * Add back cover page?
   */
  public backCoverPage = true;

  /**
   * Server-side printing?
   */
  public serverSidePrint = true;

  /**
   * Add a watermark?
   */
  public addWatermark = false;

  /**
   * Image quality
   */
  public imageQuality = 70;

  /**
   * Mark report as final?
   */
  public markAsFinal = false;

  /**
   * Password protection?
   */
  public passwordProtect = false;

  /**
   * Show terms and conditions?
   */
  public termsAndConditions = false;

  /**
   * Use compression?
   */
  public useCompression = false;

  /**
   * The watermark text
   */
  public watermarkText = 'DRAFT';

  /**
   * The paused state
   */
  public pausedState?: PausePrintRequest | string;/* stringified in DB */
}
